var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isDisjoint = require('../help/is_disjoint');

var base64url = require('../help/base64url');

var validateCrit = require('../help/validate_crit');

var _require = require('../errors'),
    JWEInvalid = _require.JWEInvalid,
    JOSENotSupported = _require.JOSENotSupported;

validateCrit = validateCrit.bind(undefined, JWEInvalid);

module.exports = function (prot, unprotected, recipients, checkAlgorithms, crit) {
  if (typeof prot === 'string') {
    try {
      prot = base64url.JSON.decode(prot);
    } catch (err) {
      throw new JWEInvalid('could not parse JWE protected header');
    }
  }

  var alg = [];
  var enc = new Set();

  if (!isDisjoint(prot, unprotected) || !recipients.every(function (_ref) {
    var header = _ref.header;

    if (typeof header === 'object') {
      alg.push(header.alg);
      enc.add(header.enc);
    }

    var combined = _objectSpread({}, unprotected, {}, header);

    validateCrit(prot, combined, crit);

    if ('zip' in combined) {
      throw new JWEInvalid('"zip" Header Parameter MUST be integrity protected');
    } else if (prot && 'zip' in prot && prot.zip !== 'DEF') {
      throw new JOSENotSupported('only "DEF" compression algorithm is supported');
    }

    return isDisjoint(header, prot) && isDisjoint(header, unprotected);
  })) {
    throw new JWEInvalid('JWE Shared Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint');
  }

  if (typeof prot === 'object') {
    alg.push(prot.alg);
    enc.add(prot.enc);
  }

  if (typeof unprotected === 'object') {
    alg.push(unprotected.alg);
    enc.add(unprotected.enc);
  }

  alg = alg.filter(Boolean);
  enc.delete(undefined);

  if (recipients.length !== 1) {
    if (alg.includes('dir') || alg.includes('ECDH-ES')) {
      throw new JWEInvalid('dir and ECDH-ES alg may only be used with a single recipient');
    }
  }

  if (checkAlgorithms) {
    if (alg.length !== recipients.length) {
      throw new JWEInvalid('missing Key Management algorithm');
    }

    if (enc.size === 0) {
      throw new JWEInvalid('missing Content Encryption algorithm');
    } else if (enc.size !== 1) {
      throw new JWEInvalid('there must only be one Content Encryption algorithm');
    }
  } else {
    if (enc.size > 1) {
      throw new JWEInvalid('there must only be one Content Encryption algorithm');
    }
  }

  return _toConsumableArray(enc)[0];
};